import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';
import { drawPath } from '@/utils/helpers/train-simulation/draw-path';

const path = new Path2D(
  'M12.514 1.594a.749.749 0 0 1 .561.22l4.909 4.907a.752.752 0 0 1-.045 1.103l-4.323 3.664.29 2.785a.752.752 0 0 1-.216.609l-1.424 1.423a.75.75 0 0 1-1.06 0l-3.192-3.191-5.14 5.14a.75.75 0 0 1-1.06-1.06l5.14-5.14L3.49 8.591a.75.75 0 0 1 0-1.061l1.424-1.424.063-.056a.751.751 0 0 1 .545-.16l2.784.288 3.666-4.32.054-.057a.75.75 0 0 1 .487-.208Z'
);
export const createPinIconAtlas = (size: number): string => {
  const res = createCanvas(size * 2, size * 2, 2);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx } = res;

  const scale = size / 20;
  ctx.scale(scale, scale);

  drawPath(ctx, path, { fill: '#FFFFFF' });

  return res.canvas.toDataURL();
};
